"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterQueryByAllDialogs = void 0;
var tslib_1 = require("tslib");
var filterQueryByAllDialogs = function (prevQuery, openedDialogs) {
  var query = {};
  Object.keys(prevQuery).map(function (key) {
    var _a;
    if (!openedDialogs.find(function (dialog) {
      return dialog.key === key;
    })) {
      query = tslib_1.__assign(tslib_1.__assign({}, query), (_a = {}, _a[key] = prevQuery[key], _a));
    }
  });
  return query;
};
exports.filterQueryByAllDialogs = filterQueryByAllDialogs;